import {Button} from '@wandb/weave/components/Button';
import React from 'react';

type LogSearchBrowserProps = {
  index: number;
  count: number;
  goToNext: () => void;
  goToPrev: () => void;
};

/**
 * This component allows jumping forwards and backwards through the
 * search results for a Log.
 */
export const LogSearchBrowser = ({
  index,
  count,
  goToNext,
  goToPrev,
}: LogSearchBrowserProps) => {
  return (
    <span className="inline-flex h-fit items-center">
      <span className="mr-8 font-semibold">
        {count === 0 ? '0/0' : `${index + 1}/${count}`}
      </span>
      <Button
        aria-label="go to previous match"
        icon="chevron-up"
        variant="ghost"
        onClick={goToPrev}
        disabled={count === 0}
      />
      <Button
        aria-label="go to next match"
        icon="chevron-down"
        variant="ghost"
        onClick={goToNext}
        disabled={count === 0}
      />
    </span>
  );
};
